import { ADD_MESSAGES } from '#app/constants/chat.ts'

import { type State, type Action } from '#types/chat/index.ts'

export function addMessages(state: State, action: Action): State {
	if (action.type !== ADD_MESSAGES) {
		return state
	}

	if (state.conversationId !== action.conversationId) {
		const allCurrentMessages = action.payload.attributes.messages.data.map(
			message => ({
				role: message.attributes.role,
				id: message.attributes.messageId,
				content: message.attributes.content,
			}),
		)

		return {
			...state,
			messages: allCurrentMessages,
			conversationId: action.conversationId,
		}
	}

	return {
		...state,
	}
}
